// extracted by mini-css-extract-plugin
export default {"dialog":"LrV0Z","header":"-N2Mf"};